import { createStyles } from '@material-ui/core/styles';

export const styles = () =>
  createStyles({
    root: {
      position: 'relative',
      width: '100%',
      height: '100%',
      zIndex: 1,
    },
    rootDisabled: {
      pointerEvents: 'none',
    },
  });
